export default {
  /*
  * Simple 'debounce' implementation
  */
  currentTokenValid (tokenExpiryDuration, lastTimeStampOfUpdate) {
    if (!tokenExpiryDuration || !lastTimeStampOfUpdate) {
      return false
    }
    /*
    * checks current time against the time of last call with a little more
    * buffer to prevent 401 responses
    */
    const currentTimestamp = new Date().getTime()
    const lastTimeStampOfUpdateWithBuffer = lastTimeStampOfUpdate - 100
    return (currentTimestamp - lastTimeStampOfUpdateWithBuffer) <= tokenExpiryDuration
  }
}



// WEBPACK FOOTER //
// ./src/modules/authorization/store/helpers.js